export const useScrollLock = () => {
  let scrollY = 0;

  const lockScroll = () => {
    scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.overflowY = "hidden";
  };

  const unlockScroll = () => {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.overflowY = "";
    window.scrollTo(0, scrollY);
  };

  return {
    lockScroll,
    unlockScroll,
  };
};
